import { render, staticRenderFns } from "./TabChapters.vue?vue&type=template&id=52e05c8c"
import script from "./TabChapters.vue?vue&type=script&setup=true&lang=js"
export * from "./TabChapters.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports